import Option from '@/components/form/types/Option.ts';
import { ParticipantLimitMode } from '@/features/dashboard/tourTransport/types/ParticipantLimitMode.ts';

export const participantLimitModeLabels: Record<ParticipantLimitMode, string> = {
  [ParticipantLimitMode.UNLIMITED]: 'Brak limitu',
  [ParticipantLimitMode.LIMITED]: 'Limit miejsc',
};

export const participantLimitModeToggleOptions: Option[] = Object.values(
  ParticipantLimitMode,
).map((value) => ({
  value,
  label: participantLimitModeLabels[value],
}));
